let config = null;

export async function loadConfig() {
  if (!config) {
    const response = await fetch('/config.json');
    config = await response.json();

    const configuredPathwaysUrl = String(process.env.REACT_APP_PATHWAYS_URL || '').trim();
    if (configuredPathwaysUrl) {
      config = { ...config, PATHWAYS_URL: configuredPathwaysUrl };
    }
  }
  return config;
}